const css = `.wHtCuq__userContext{text-align:right;min-width:140px;flex:16%}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"userContext":"wHtCuq__userContext"};
